/**
 * Умная фоновая подгрузка текущего урока.
 *
 * На главной и карте прогревается урок, который ученик пройдёт следующим:
 * сначала пауза `LESSON_PREFETCH_DELAY_MS` (случайный заход токенов не
 * тратит), потом — запрос в фон. Уход с экрана отменяет ещё не начатую
 * подгрузку; скрытая вкладка ставит всё на паузу.
 *
 * Возвращает `ready` — урок уже в памяти; по нему показывается зелёная точка.
 */

import { useEffect } from 'react';

import { cancelScheduledLessonPrefetch, scheduleLessonPrefetch } from '../lib/lessonPrefetcher';
import { isPrefetchedLessonFresh, lessonPrefetchKey, useLessonPrefetchStore } from '../store/lessonPrefetchStore';
import { useUserStore } from '../store/userStore';

/** Есть ли свежий урок в памяти — реактивно, для индикатора. */
export function usePrefetchedLessonReady(userId: string, skillId: string | null | undefined): boolean {
  const key = skillId !== null && skillId !== undefined && skillId.length > 0 ? lessonPrefetchKey(userId, skillId) : null;
  return useLessonPrefetchStore((state) => (key === null ? false : isPrefetchedLessonFresh(state.lessons[key])));
}

export function useLessonPrefetch(skillId: string | null | undefined): boolean {
  const userId = useUserStore((state) => state.userId);

  useEffect(() => {
    if (userId.length === 0 || skillId === null || skillId === undefined || skillId.length === 0) return undefined;
    scheduleLessonPrefetch(userId, skillId);
    return () => cancelScheduledLessonPrefetch(userId, skillId);
  }, [userId, skillId]);

  return usePrefetchedLessonReady(userId, skillId);
}
